import { render, staticRenderFns } from "./selected-manufacturer.vue?vue&type=template&id=62b5a22d"
import script from "./selected-manufacturer.vue?vue&type=script&lang=ts"
export * from "./selected-manufacturer.vue?vue&type=script&lang=ts"
import style0 from "./selected-manufacturer.vue?vue&type=style&index=0&id=62b5a22d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports